import { Component,OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {FormGroup,FormControl,Validators } from '@angular/forms';
import {MatSnackBar} from '@angular/material';

import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireStorage } from '@angular/fire/storage';

import $ from "jquery";
import {finalize} from 'rxjs/operators';


import { Post,UrlAttachment,Image } from '../../models/models';
import { PostService,UrlAttachmentService,ImageService } from '../../services/firebase/firebase.service';
import { MetadataService } from '../../services/url/metadata.service';

import { LoadingBarService } from '@ngx-loading-bar/core';

/**
 * Generated class for the WritePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-write',
  templateUrl: 'write.html',
  styleUrls: ['./write.scss']

})
export class WritePage implements OnInit {
	post = {} as Post;
	url_attachment = {} as UrlAttachment;
	image = {} as Image;
	posting=false;
	hasUrl=false;
	urlLoading=false;
	formPost:FormGroup;

	url_fetch;
	uploadPercent;
	

	//Constructor
	constructor(private afAuth:AngularFireAuth,
	public storage:AngularFireStorage,
	private postService:PostService,
	private imageService:ImageService,
	private url_attachmentService:UrlAttachmentService,
	private metadata:MetadataService,
	private route: ActivatedRoute,
	private router: Router,
	public snackBar: MatSnackBar,
	private loadingBar: LoadingBarService) {}

	 ngOnInit() {

	 	this.formPost = new FormGroup({			
			'text': new FormControl(this.post.text, [Validators.required, Validators.maxLength(200)]),
			'emotion': new FormControl('', Validators.required),
			'url': new FormControl()
		});		
		
		/*this.formPost.get('url').valueChanges.subscribe( url =>{
			this.urlLoading= ((url!=='')&&(this.url_fetch===null))? true : false ;
		});*/
	}
	  
	change(e){
		let text = $('textarea').val();
		let text_length = text.length;
		let text_remaining = 200 - text_length;
		$('#count_message').html(text_remaining + ' remaining');

	}
  
  
	async sendPost(){ 
		this.posting=true;
		this.loadingBar.start();
	
	  
	  	let post = this.formPost.value;



		if(this.formPost.invalid){ 
			this.loadingBar.complete();
			this.posting=false;
			this.presentToast("Texto ou Emoticon não preenchido");
		}else{
			//Linha abaixo error
			post.created_at = (new Date()).toString();
			post.timestamp =  ((Date.now()) *-1) ;
			
			if(this.url_fetch){		

				//Image
				let uniqkey = 'pic' + Math.floor(Math.random() * 1000000);
				let fileName = `/images/uploads/${uniqkey}`;
				let ref = this.storage.ref(fileName);

				const upload = this.storage.ref(fileName).putString(this.url_fetch.image, 'base64',{contentType: 'image/png'});
					
				this.uploadPercent = upload.percentageChanges();	
		

				upload.snapshotChanges().pipe(finalize(() => {
								
					ref.getDownloadURL().subscribe(url => {
								
						console.log(url);
						this.image = {
							public_url:url,
							created_at: (new Date()).toString(),
							timestamp :  ((Date.now()) *-1),
							alt : this.url_fetch.title,
						}
									
						let img_id = this.imageService.addImage(this.image);
									
						this.url_attachment = {
							title:this.url_fetch.title,
							description: this.url_fetch.description ? this.url_fetch.description  : "" ,
							url:this.url_fetch.url,
							created_at: (new Date()).toString(),
							timestamp:  ((Date.now()) *-1) ,
							image_id:img_id,
						}
													
						post.url_attachment_id =  this.url_attachmentService.addUrlAttachment(this.url_attachment);
						
						this.postService.addPost(post);
						this.posting=false;
						this.loadingBar.complete();
						this.gotToHome();
					});
				})).subscribe();
				
			}else{
				this.postService.addPost(post);
				this.posting=false;
				this.loadingBar.complete();
				this.gotToHome();
			}	
		}
	}

	gotToHome(){
		this.presentToast("Menssagem Postada Com Sucesso!");
		//Redirecionar para inicio
		this.router.navigate(['']);		
	}
	
	presentToast(message) {
		this.snackBar.open(message,"Fechar",{duration: 3000}).onAction().subscribe(() => {
			this.snackBar.dismiss();
		});
	}
	
	makeLogout(){
		this.afAuth.auth.signOut();
		this.router.navigate(['']);
	}



	getUrl(e){
		this.url_fetch=null;
		this.urlLoading=true;
		this.metadata.get(e.target.value).then(json =>{
			this.url_fetch = json;
			this.hasUrl = true;
			this.urlLoading=false;
		});

	}
	
	
}